<template>
  <div :class="isMobile == 0 ? '' : 'yacht_mobile'" class="yacht">
    <div v-if="showModal" class="modal-overlay" @click="closeModal" style="">
      <img class="modal-image" :src="selectedImageSrc" @click.stop />
      <span class="close-button" @click="closeModal">×</span>
    </div>

    <!-- 顶部banner：添加动画类 -->
    <div :class="isMobile == 0 ? '' : 'yacht-top_mobile'" class="yacht-top animate-fade-in">
      <img class="yacht-bg1" :src="'https://app.choisiyachts.com' + getImg('interior', 0)" />
      <img :class="isMobile == 0 ? '' : 'yacht-top-bgsm_mobile'" class="yacht-top-bgsm"
        :src="'https://app.choisiyachts.com' + getImg('interior_index', 0)" alt="yacht" />
    </div>

    <!-- 中间文本：添加动画类 -->
    <div :class="isMobile == 0 ? '' : 'yacht-center-text_mobile'" class="yacht-center-text animate-fade-in"
      v-html="this.yachatdDetail?.translations?.description?.content || ''">
    </div>

    <!-- 中间大图：添加动画类 -->
    <img :class="isMobile == 0 ? '' : 'yacht-bg2_mobile'" class="yacht-bg2 animate-fade-in"
      :src="'https://app.choisiyachts.com' + getImg('exterior_index', 0)"></img>

    <!-- 选项卡导航：添加动画类 -->
    <div v-if="isMobile == 0" class="yacht-sels animate-fade-in">
      <div class="yacht-sel-boxs">
        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'experience' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          @click="epsm('experience')">
          Experience
        </div>
        <div v-else class="yacht-sel" :style="epsmType == 'experience' ? 'border-bottom:3px solid #6488C6;' : ''"
          @click="epsm('experience')">
          经历
        </div>

        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'product_design' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          @click="epsm('product_design')">Product
          Design</div>
        <div v-else class="yacht-sel" :style="epsmType == 'product_design' ? 'border-bottom:3px solid #6488C6;' : ''"
          @click="epsm('product_design')">产品设计</div>

        <img class="yacht-sel-logo" src="../assets/logo.png" alt="yacht" />
        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'facility' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          @click="epsm('facility')">
          Specifications and layout</div>
        <div v-else class="yacht-sel" :style="epsmType == 'facility' ? 'border-bottom:3px solid #6488C6;' : ''"
          @click="epsm('facility')">
          规格和布局</div>

        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'manual' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''" @click="epsm('manual')">
          Enquiry</div>

        <div v-else class="yacht-sel" :style="epsmType == 'manual' ? 'border-bottom:3px solid #6488C6;' : ''"
          @click="epsm('manual')">
          询问</div>

      </div>
    </div>

    <div v-if="isMobile == 1" class="yacht-sels_mobile animate-fade-in" style="border-bottom: 1px solid #6488C6;">
      <div v-if="epsmType == 'experience'" @click="mobileSelShow = !mobileSelShow">
        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'experience' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          style="font-size: 20px;margin-right: 5px;height: 45px;">
          Experience
        </div>
        <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
          :style="epsmType == 'experience' ? 'border-bottom:3px solid #6488C6;' : ''">
          经历
        </div>
      </div>
      <div v-if="epsmType == 'product_design'" @click="mobileSelShow = !mobileSelShow">
        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'product_design' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          style="font-size: 20px;margin-right: 5px;height: 45px;">
          Product
        </div>
        <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
          :style="epsmType == 'product_design' ? 'border-bottom:3px solid #6488C6;' : ''">
          产品设计
        </div>
      </div>
      <div v-if="epsmType == 'facility'" @click="mobileSelShow = !mobileSelShow">
        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'experience' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          style="font-size: 20px;margin-right: 5px;height: 45px;">
          Specifications and layout
        </div>
        <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
          :style="epsmType == 'facility' ? 'border-bottom:3px solid #6488C6;' : ''">
          规格和布局
        </div>
      </div>
      <div v-if="epsmType == 'manual'" @click="mobileSelShow = !mobileSelShow">
        <div v-if="lang.fyType == 2" class="yacht-sel"
          :style="epsmType == 'manual' ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
          style="font-size: 20px;margin-right: 5px;height: 45px;">
          Enquiry
        </div>
        <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
          :style="epsmType == 'manual' ? 'border-bottom:3px solid #6488C6;' : ''">
          询问
        </div>
      </div>

      <div v-if="mobileSelShow" style="position: absolute;border: 1px solid;background: white;z-index: 99999;
        top: 78%;padding-bottom: 20px;border-radius: 15px;padding-left: 5px;">
        <div>
          <div v-if="lang.fyType == 2" class="yacht-sel" :style="epsmType == 'experience' ? 'color:#6488C6' : ''"
            @click="epsm('experience')" style="font-size: 20px;height: 30px;">
            Experience
          </div>
          <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;"
            :style="epsmType == 'experience' ? '' : ''" @click="epsm('experience')">
            经历
          </div>
        </div>
        <div>
          <div v-if="lang.fyType == 2" class="yacht-sel" :style="epsmType == 'product_design' ? 'color:#6488C6' : ''"
            @click="epsm('product_design')" style="font-size: 20px;height: 30px;">Product
            Design</div>
          <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;"
            :style="epsmType == 'product_design' ? '' : ''" @click="epsm('product_design')">产品设计</div>
        </div>
        <div>
          <div v-if="lang.fyType == 2" class="yacht-sel" :style="epsmType == 'facility' ? 'color:#6488C6' : ''"
            @click="epsm('facility')" style="font-size: 20px;height: 30px;">
            Specifications and layout</div>
          <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;" :style="epsmType == 'facility' ? '' : ''"
            @click="epsm('facility')">
            规格和布局</div>
        </div>
        <div>
          <div v-if="lang.fyType == 2" class="yacht-sel" :style="epsmType == 'manual' ? 'color:#6488C6' : ''"
            style="font-size: 20px;height: 30px;" @click="epsm('manual')">
            Enquiry</div>

          <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;" :style="epsmType == 'manual' ? '' : ''"
            @click="epsm('manual')">
            询问</div>
        </div>
      </div>
      <img class="sel_img_mobile" src="../assets/sel.png" />
      <img class="yacht-sel-logo_mobile" src="../assets/logo.png" alt="yacht" />

    </div>


    <!-- <div v-if="isMobile==1" ></div> -->
    <div class="tcMobile" v-if="tcShows == 1">
      <div @click.stop="tcshow(0)" class="tcMobilecontent"
        v-html="this.yachatdDetail?.translations?.experience_description?.content || ''">
      </div>
    </div>
    <!-- 选项卡内容区：添加动画类 -->
    <div @click="tcshow(1)" class="yacht-sel-box animate-fade-in" id="toExperience" style=" width: 98%;
  margin: 0px auto;">
      <div :class="isMobile == 0 ? '' : 'yacht-sel-text1_mobile'" class="yacht-sel-text1"
        v-html="this.yachatdDetail?.translations?.experience_subtitle?.content || ''"></div>
      <div :class="isMobile == 0 ? '' : 'yacht-sel-text2_mobile'" class="yacht-sel-text2">
        <div :class="isMobile == 0 ? '' : 'yacht-sel-text3_mobile'" class="yacht-sel-text3"
          v-html="this.yachatdDetail?.translations?.experience_description?.content || ''"></div>
        <div @click="tcshow(1)" style="color: #6488C6;align-items: center;">View More~</div>
      </div>
      <div :class="isMobile == 0 ? '' : 'yacht-sel-img-box_mobile'" class="yacht-sel-img-box">
        <!-- 选项卡图片：按索引设置延迟 -->
        <img :class="isMobile == 0 ? '' : 'yacht-sel-img1_mobile'" class="yacht-sel-img1 animate-fade-in"
          :src="'https://app.choisiyachts.com' + getImg('experience', 0)" :style="{ animationDelay: '1.5s' }" />
        <img :class="isMobile == 0 ? '' : 'yacht-sel-img2_mobile'" class="yacht-sel-img2 animate-fade-in"
          :src="'https://app.choisiyachts.com' + getImg('product_design', 0)" :style="{ animationDelay: '1.8s' }" />
        <img :class="isMobile == 0 ? '' : 'yacht-sel-img3_mobile'" class="yacht-sel-img3 animate-fade-in"
          :src="'https://app.choisiyachts.com' + getImg('spec_layout', 0)" :style="{ animationDelay: '2.1s' }" />
        <img :class="isMobile == 0 ? '' : 'yacht-sel-img4_mobile'" class="yacht-sel-img4 animate-fade-in"
          :src="'https://app.choisiyachts.com' + getImg('inquiry', 0)" :style="{ animationDelay: '2.4s' }" />
      </div>
      <div :class="isMobile == 0 ? '' : 'yacht-sel-text1_mobile'" class="yacht-sel-text1 animate-fade-in"
        :style="{ animationDelay: '2.7s' }">{{
          this.yachatdDetail?.translations?.bottom_description_1?.content || '' }}</div>
    </div>

    <!-- 精美设计区：添加动画类 -->
    <div class="yacht-detail animate-fade-in">
      <div :class="isMobile == 0 ? '' : 'yacht-detail-title_mobile'" id="amazing-design" class="yacht-detail-title"
        v-if="lang.fyType == 2">Amazing design</div>
      <div :class="isMobile == 0 ? '' : 'yacht-detail-title_mobile'" id="amazing-design" class="yacht-detail-title"
        v-else>
        精美设计</div>
      <div class="yacht-detail-sel" v-if="isMobile == 0">
        <div class="yacht-detail-sel-box" style="width: 78%;margin: 0px auto;">
          <div v-if="lang.fyType == 2" class="yacht-detail-sel-title"
            :style="aicType == 0 ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''" @click="aic(0)">Appearance
          </div>
          <div v-else class="yacht-detail-sel-title" :style="aicType == 0 ? 'border-bottom:3px solid #6488C6;' : ''"
            @click="aic(0)">外观</div>


          <div v-if="lang.fyType == 2" class="yacht-detail-sel-title" style="margin-left: 150px;"
            :style="aicType == 1 ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''" @click="aic(1)">Interior</div>
          <div v-else class="yacht-detail-sel-title" :style="aicType == 1 ? 'border-bottom:3px solid #6488C6;' : ''"
            style="margin-left: 80px;" @click="aic(1)">内饰</div>


          <div v-if="lang.fyType == 2" class="yacht-detail-sel-title"
            :style="aicType == 2 ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''" @click="aic(2)">Choose
            decorative materials</div>
          <div v-else class="yacht-detail-sel-title" :style="aicType == 2 ? 'border-bottom:3px solid #6488C6;' : ''"
            @click="aic(2)">选择装饰材料</div>

        </div>
      </div>

      <div v-if="isMobile == 1" class="yacht-sels_mobile animate-fade-in">
        <div v-if="aicType == 0" @click="mobileSelShow2 = !mobileSelShow2">
          <div v-if="lang.fyType == 2" class="yacht-sel"
            :style="aicType == 0 ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
            style="font-size: 20px;margin-right: 5px;height: 45px;">
            Appearance
          </div>
          <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
            :style="aicType == 0 ? 'border-bottom:3px solid #6488C6;' : ''">
            外观
          </div>
        </div>
        <div v-if="aicType == 1" @click="mobileSelShow2 = !mobileSelShow2">
          <div v-if="lang.fyType == 2" class="yacht-sel"
            :style="aicType == 1 ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
            style="font-size: 20px;margin-right: 5px;height: 45px;">
            Interior
          </div>
          <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
            :style="aicType == 1 ? 'border-bottom:3px solid #6488C6;' : ''">
            内饰
          </div>
        </div>
        <div v-if="aicType == 2" @click="mobileSelShow2 = !mobileSelShow2">
          <div v-if="lang.fyType == 2" class="yacht-sel"
            :style="aicType == 2 ? 'border-bottom:3px solid #6488C6;color:#6488C6' : ''"
            style="font-size: 20px;margin-right: 5px;height: 45px;">
            Choose decorative materials
          </div>
          <div style="font-size: 20px;margin-right: 5px;height: 45px;" v-else class="yacht-sel"
            :style="aicType == 2 ? 'border-bottom:3px solid #6488C6;' : ''">
            选择装饰材料
          </div>
        </div>

        <div v-if="mobileSelShow2" style="position: absolute;border: 1px solid;background: white;z-index: 99999;
        top: 78%;padding-bottom: 20px;border-radius: 15px;padding-left: 5px;">
          <div>
            <div v-if="lang.fyType == 2" class="yacht-sel" :style="aicType == 0 ? 'color:#6488C6' : ''" @click="aic(0)"
              style="font-size: 20px;height: 30px;">
              Appearance
            </div>
            <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;" :style="aicType == 0 ? '' : ''"
              @click="aic(0)">
              外观
            </div>
          </div>
          <div>
            <div v-if="lang.fyType == 2" class="yacht-sel" :style="aicType == 1 ? 'color:#6488C6' : ''" @click="aic(1)"
              style="font-size: 20px;height: 30px;">Interior</div>
            <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;" :style="aicType == 1 ? '' : ''"
              @click="aic(1)">内饰</div>
          </div>
          <div>
            <div v-if="lang.fyType == 2" class="yacht-sel" :style="aicType == 2 ? 'color:#6488C6' : ''" @click="aic(2)"
              style="font-size: 20px;height: 30px;">
              Choose decorative materials</div>
            <div v-else class="yacht-sel" style="font-size: 20px;height: 30px;" :style="aicType == 2 ? '' : ''"
              @click="aic(2)">
              选择装饰材料</div>
          </div>
        </div>
        <img class="sel_img_mobile" src="../assets/sel.png" />

      </div>
      <div :class="isMobile == 0 ? '' : 'yacht-detail-img_mobile'" class="yacht-detail-img-box animate-fade-in"
        :style="{ animationDelay: '3s' }">
        <div>
          <img :class="isMobile == 0 ? '' : 'yacht-detail-img_mobile'" class="yacht-detail-img"
            :src="'https://app.choisiyachts.com' + imgArr[currentIndex]" />
          <!-- <img class="yacht-detail-img" v-if="aicType==0" v-for="src in getImgArr('exterior_index')" :src="'https://app.choisiyachts.com' +src" /> -->

        </div>
        <!-- <img class="yacht-detail-img" v-if="aicType==0" v-for="src in getImgArr('exterior_index')" :src="'https://app.choisiyachts.com' +src" /> -->
        <!-- <img class="yacht-detail-img" v-if="aicType==0" :src="'https://app.choisiyachts.com' + getImg('interior_detail',0)" />

        <img class="yacht-detail-img" v-if="aicType==1" :src="'https://app.choisiyachts.com' + getImg('interior_detail',0)" />
        <img class="yacht-detail-img" v-if="aicType==2" :src="'https://app.choisiyachts.com' + getImg('exterior_detail',0)" /> -->

        <div :class="isMobile == 0 ? '' : 'yacht-detail-leftright_mobile'" class="yacht-detail-leftright">
          <img class="yacht-detail-toleft" src="../assets/toleft.png" @click="changenext(1)" />
          <img class="yacht-detail-toright" src="../assets/toright.png" @click="changenext(2)" />
        </div>
        <img v-if="isMobile == 0" class="yacht-detail-tobig" src="../assets/tobig.png" @click="openModal(1)" />
      </div>

      <!-- 目标2：Product Design → Every perfect detail（添加ID） -->
      <div :class="isMobile == 0 ? '' : 'yacht-detail-cont_mobile'" id="every-perfect-detail"
        class="yacht-detail-cont animate-fade-in" :style="{ animationDelay: '3.3s' }" v-if="lang.fyType == 2">Every
        perfect detail</div>
      <div :class="isMobile == 0 ? '' : 'yacht-detail-cont_mobile'" id="every-perfect-detail"
        class="yacht-detail-cont animate-fade-in" :style="{ animationDelay: '3.3s' }" v-else>每一处细节都精美</div>

      <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-box_mobile'" class="yacht-detail-cont-box animate-fade-in"
        :style="{ animationDelay: '3.6s' }">
        <img :class="isMobile == 0 ? '' : 'yacht-detail-cont-img_mobile'" class="yacht-detail-cont-img"
          :src="'https://app.choisiyachts.com' + getImg('main_deck', 0)" />
        <div class="yacht-detail-cont-img-right">
          <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-text_mobile'" class="yacht-detail-cont-text"
            v-if="lang.fyType == 2">Top speed Knots</div>
          <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-text_mobile'" class="yacht-detail-cont-text" v-else>最高航速
          </div>

          <div :class="isMobile == 0 ? '' : 'ydct_line_mobile'" class="ydct_line">
            <div class="ydct_line_line">
              <div v-if="isMobile == 0"
                style="width: 475px;height: 6px;background: #F0F3F9;border-radius: 0px 0px 0px 0px;"></div>
              <div v-if="isMobile == 1"
                style="width:100px;height: 6px;background: #F0F3F9;border-radius: 0px 0px 0px 0px;"></div>

              <div class="ydct_line_line_pos"></div>
            </div>
            {{ yachatdDetail.max_speed }}
          </div>
          <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-text_mobile'" class="yacht-detail-cont-text"
            v-if="lang.fyType == 2">Length Metres</div>
          <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-text_mobile'" class="yacht-detail-cont-text" v-else>长度
          </div>

          <div :class="isMobile == 0 ? '' : 'ydct_line_mobile'" class="ydct_line">
            <div class="ydct_line_line">
              <div v-if="isMobile == 0"
                style="width: 475px;height: 6px;background: #F0F3F9;border-radius: 0px 0px 0px 0px;"></div>
              <div v-if="isMobile == 1"
                style="width:100px;height: 6px;background: #F0F3F9;border-radius: 0px 0px 0px 0px;"></div>
              <div class="ydct_line_line_pos"></div>
            </div>
            {{ yachatdDetail.length }}
          </div>

          <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-text_mobile'" class="yacht-detail-cont-text"
            v-if="lang.fyType == 2">Berths People</div>
          <div :class="isMobile == 0 ? '' : 'yacht-detail-cont-text_mobile'" class="yacht-detail-cont-text" v-else>客舱
          </div>
          <div :class="isMobile == 0 ? '' : 'ydct_line_mobile'" class="ydct_line">
            <div class="ydct_line_line">
              <div v-if="isMobile == 0"
                style="width: 475px;height: 6px;background: #F0F3F9;border-radius: 0px 0px 0px 0px;"></div>
              <div v-if="isMobile == 1"
                style="width:100px;height: 6px;background: #F0F3F9;border-radius: 0px 0px 0px 0px;"></div>
              <div class="ydct_line_line_pos"></div>
            </div>
            {{ yachatdDetail.passenger_capacity }}
          </div>
        </div>
      </div>



      <div :class="isMobile == 0 ? '' : 'yacht-detail-sm_mobile'" class="yacht-detail-sm animate-fade-in"
        :style="{ animationDelay: '3.9s' }" style="position: relative;">
        <!-- 目标3：Specifications and layout → Specifications（添加ID） -->
        <div v-if="ifMobile == 0">
          <div id="specifications" class="yacht-detail-sm-title" style=" margin-right: 560px;" v-if="lang.fyType == 2">
            Specifications</div>
          <div id="specifications" class="yacht-detail-sm-title" style=" margin-right: 560px;" v-else>规格</div>
        </div>
        <div v-else>
          <div :style="{ 'font-size': isMobile == 1 ? '15px' : '' }" id="specifications" class="yacht-detail-sm-title"
            style=" margin-right:40px;" v-if="lang.fyType == 2">
            Specifications</div>
          <div :style="{ 'font-size': isMobile == 1 ? '15px' : '' }" id="specifications" class="yacht-detail-sm-title"
            style=" margin-right:40px;" v-else>规格</div>
        </div>


        <div :class="ydstType == 2 ? 'ydst_sel' : ''" @click="selYdst(2)" v-if="lang.fyType == 2"
          class="yacht-detail-sm-title" :style="{ 'font-size': isMobile == 1 ? '15px' : '' }">Main dimensions
        </div>
        <div :style="{ 'font-size': isMobile == 1 ? '15px' : '' }" :class="ydstType == 2 ? 'ydst_sel' : ''"
          @click="selYdst(1)" v-else class="yacht-detail-sm-title">主要尺寸
        </div>
        <!-- 切换图标：添加动态旋转类 -->
        <img @click="ifSelShow = !ifSelShow"
          style="width: 21px;height: 12px;position: absolute;top: 50%;right: 0;transform: translate(0,-50%);transition: transform 0.3s ease;"
          src="../assets/sel.png" :class="{ 'rotate-icon': ifSelShow }" />
      </div>

      <div :class="isMobile == 0 ? '' : 'ydst_line_mobile'" class="ydst_line animate-fade-in"
        :style="{ animationDelay: '3.9s' }"></div>

      <!-- 规格列表：用transition包裹实现滑动效果 -->
      <!-- <transition name="slide-down"> -->
      <div :class="isMobile == 0 ? '' : 'ydst_spec_bigbox_mobile'" class="ydst_spec_bigbox animate-fade-in"
        v-show="ifSelShow">
        <div :class="isMobile == 0 ? '' : 'ydst_spec_mobile'" class="ydst_spec"
          v-for="(item, index) in yachatdDetail?.specs || []" :key="index">
          <div class="ydst_spec_title" v-if="lang.fyType == 2">{{ item.spec_name_en }}</div>
          <div class="ydst_spec_title" v-else>{{ item.spec_name_zh }}</div>

          <div :class="isMobile == 0 ? '' : 'ydstsb_line_mobile'" class="ydstsb_line"></div>
          <div class="ydst_spec_title" v-if="lang.fyType == 2">{{ item.spec_value_en }}/{{ item.spec_unit }}</div>
          <div class="ydst_spec_title" v-else>{{ item.spec_value_zh }}/{{ item.spec_unit }}</div>
          <!-- <div class="ydst_spec_title">{{ item.spec_value }}/{{ item.spec_unit }}</div> -->
        </div>
      </div>
      <!-- </transition> -->

      <!-- 甲板图片组：按顺序设置延迟 -->
      <div :class="isMobile == 0 ? '' : 'yacht-detail-sm-img-box_mobile'" v-for="(item, index) in bottomList"
        :key="index" class="yacht-detail-sm-img-box animate-fade-in" :style="{ animationDelay: '4.5s' }"
        style="margin-top: 32px;">
        <div class="ydsib_line">
          <img :class="isMobile == 0 ? '' : 'yacht-detail-sm-img_mobile'" class="yacht-detail-sm-img"
            :src="'https://app.choisiyachts.com' + item" />
          <img v-if="isMobile == 0" :class="isMobile == 0 ? '' : 'yacht-detail-sm-img-tobig_mobile'" class="yacht-detail-sm-img-tobig"
            src="../assets/tobig.png" @click="openModal(item)" />
        </div>
        <div :class="isMobile == 0 ? '' : 'yacht-detail-sm-img-text_mobile'" class="yacht-detail-sm-img-text">{{
          bottomAlt[index] }}</div>
      </div>


      <div :class="isMobile == 0 ? '' : 'yacht-sel-text1_mobile'" class="yacht-sel-text1 animate-fade-in"
        :style="{ animationDelay: '5.4s' }">{{
          this.yachatdDetail?.translations?.bottom_description_2?.content || '' }}</div>


      <div :class="isMobile == 0 ? '' : 'yacht-detail-bot-img-box_mobile'"
        class="yacht-detail-bot-img-box animate-fade-in" :style="{ animationDelay: '5.7s' }">
        <img class="yacht-detail-bot-img" src="../assets/btbg.png" />
        <div :class="isMobile == 0 ? '' : 'yacht-detail-bot-img-text_mobile'" class="yacht-detail-bot-img-text"
          v-if="lang.fyType == 2">View more content</div>
        <div :class="isMobile == 0 ? '' : 'yacht-detail-bot-img-text_mobile'" class="yacht-detail-bot-img-text" v-else>
          查看更多内容
        </div>
        <div :class="isMobile == 0 ? '' : 'acht-detail-bot-img-buts_mobile'" class="acht-detail-bot-img-buts">
          <div @click="goContect" class="yacht-detail-bot-img-but" v-if="lang.fyType == 2"
            style="margin-right: 70px;align-items: center;display: flex;justify-content: center;">Enquire
            <img src="../assets//bluenext.png" style="width: 8px;height: 14px;margin-left: 10px;" />

          </div>
          <div @click="goContect" class="yacht-detail-bot-img-but" v-else
            style="margin-right: 70px;align-items: center;display: flex;justify-content: center;">询问
            <img src="../assets//bluenext.png" style="width: 8px;height: 14px;margin-left: 10px;" />
          </div>
          <div @click="goContect" class="yacht-detail-bot-img-but" v-if="lang.fyType == 2"
            style="align-items: center;display: flex;justify-content: center;">Order
            <img src="../assets//bluenext.png" style="width: 8px;height: 14px;margin-left: 10px;" />
          </div>
          <div @click="goContect" class="yacht-detail-bot-img-but" v-else
            style="align-items: center;display: flex;justify-content: center;">预约
            <img src="../assets//bluenext.png" style="width: 8px;height: 14px;margin-left: 10px;" />
          </div>
        </div>
      </div>
    </div>
    <!-- 目标4：Manual → 最底部（添加ID） -->
    <bottom :if-show="true" id="page-bottom" class="animate-fade-in" :style="{ animationDelay: '6s' }"></bottom>
  </div>
</template>

<script>
// 脚本部分保持不变
import bottom from './bottom.vue';
import router from '@/router';
import { GoodDetail } from '../../request/api.js'
export default {
  components: {
    bottom
  },
  name: 'Yacht',
  data() {
    return {
      mobileSelShow: false,
      mobileSelShow2: false,

      lang: {},
      epsmType: 'experience',
      aicType: 0,
      yachatdDetail: null,
      ydstType: 2,
      showModal: false,
      selectedImageSrc: '',
      ifSelShow: true,
      aicTypeIndex: 0,
      currentIndex: 0,
      timer: null,
      bottomList: [],
      bottomAlt: [],

      isMobile: 0,
      tcShows: 0
    }
  },
  computed: {
    yachatId() {
      return this.$route.params.id || '未知船艇';
    },
  },
  mounted() {
    this.isMobile = localStorage.getItem('isMobile')
    this.lang = JSON.parse(localStorage.getItem('Lang'))
    if (this.lang.fyType == 2) {
      this.getGoodDetail('en')
    } else {
      this.getGoodDetail('zh')
    }
    window.addEventListener('langChange', () => {
      this.syncLangFromStorage();
    });
  },
  beforeUnmount() {
    // 组件卸载前清除定时器，防止内存泄漏
    clearInterval(this.timer);
  },
  created() {
    this.loadProjectData();
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        // 比较新旧路由的 t 参数，不同则刷新数据
        if (newRoute.query.t !== oldRoute.query.t) {
          this.refreshPageData(); // 自定义刷新方法
        }
      },
      immediate: true // 初始加载时也执行一次（确保首次有数据）
    },
    lang: {
      handler(newLang, oldLang) {
        console.log('Lang 变化了：', newLang);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    tcshow(type) {
      this.tcShows = type
      console.log(this.tcShows)
    },
    startCarousel() {
      return
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      console.log(this.imgArr.length)
      // 只有当图片数量大于1时才启动轮播（避免单图无效切换）
      if (this.imgArr.length <= 1) return;

      this.timer = setInterval(() => {
        // 索引自增，超过数组长度时重置为0（实现循环轮播）
        this.currentIndex = (this.currentIndex + 1) % this.imgArr.length;
      }, 2000); // 2000毫秒 = 2秒
    },
    refreshPageData() {
      // 1. 清空旧数据（避免视图残留）
      this.yachatdDetail = [];

      // 2. 根据当前语言重新加载数据
      if (this.lang.fyType == 2) {
        this.getGoodDetail('en')
      } else {
        this.getGoodDetail('zh')
      }
    },
    goContect() {
      console.log('goContect')
      // 1. 解析路由对应的完整 URL（自动处理基础路径 base 等配置）
      const { href } = this.$router.resolve('/Contact-us')
      // 2. 用 window.open 打开新页面，'_blank' 表示新标签页
      window.open(href, '_blank')
    },
    syncLangFromStorage() {
      this.lang = JSON.parse(localStorage.getItem('Lang'))
      console.log(this.lang)
      if (this.lang.fyType == 2) {
        this.getGoodDetail('en')
      } else {
        this.getGoodDetail('zh')
      }
    },
    changenext(type) {
      if (type == 1) {
        this.currentIndex = (this.currentIndex + 1) % this.imgArr.length;
        console.log(this.currentIndex)
      } else {
        this.currentIndex = (this.currentIndex + 1) % this.imgArr.length;
        console.log(this.currentIndex)

      }
      return

      this.currentIndex = 0
      if (type == 1) {
        this.aicType = this.aicType - 1;
        if (this.aicType < 0) {
          this.aicType = 2;
        }
      } else {
        this.aicType = this.aicType + 1;
        if (this.aicType > 2) {
          this.aicType = 0
        }
      }
    },
    selYdst(type) {
      this.ydstType = type;
    },
    getImg(str, index) {
      if (!this.yachatdDetail) return '';
      for (let i = 0; i < this.yachatdDetail.images.length; i++) {
        if (this.yachatdDetail.images[i].image_type == str) {
          return this.yachatdDetail.images[i].image_url.split(',')[index] || ''
        }
      }
    },
    getImgArr(str) {
      for (let i = 0; i < this.yachatdDetail.images.length; i++) {
        if (this.yachatdDetail.images[i].image_type == str) {
          this.imgArr = this.yachatdDetail.images[i].image_url.split(',')
          // return this.yachatdDetail.images[i].image_url.split(',')|| ''
        }
      }
    },
    getParams(value) {
      if (!this.yachatdDetail) return {};
      for (let i = 0; i < this.yachatdDetail.specs.length; i++) {
        if (this.yachatdDetail.specs[i].spec_name == value) {
          return this.yachatdDetail.specs[i]
        }
      }
      return {};
    },
    loadProjectData() {
      this.getGoodDetail()
    },
    getGoodDetail(language) {
      let data = {
        id: this.yachatId,
        language
      }
      GoodDetail(data).then(res => {
        this.yachatdDetail = res.data
        console.log(res)

        this.aic(0)
        this.startCarousel();
        for (let i = 0; i < this.yachatdDetail.images.length; i++) {
          if (this.yachatdDetail.images[i].image_type == 'lower_deck') {
            this.bottomList = this.yachatdDetail.images[i].image_url.split(',')
            this.bottomAlt = this.yachatdDetail.images[i].alt.split(',')
          }
        }

      }).catch(err => {
        console.log(err)
      })
    },
    // 核心修改：选项卡切换+滚动逻辑
    epsm(type) {
      if (this.isMobile == 1) {
        this.mobileSelShow = false
      }
      this.epsmType = type; // 先切换选项卡类型

      // 等待DOM更新后执行滚动（确保目标元素已渲染）
      this.$nextTick(() => {
        let targetId = '';
        // 匹配选项卡对应的目标区域ID
        switch (type) {
          case 'experience':
            targetId = 'toExperience'; // Experience → Amazing design
            break;
          case 'product_design':
            targetId = 'amazing-design'; // Product Design → Every perfect detail
            break;
          case 'facility':
            targetId = 'every-perfect-detail'; // Specifications and layout → Specifications
            break;
          case 'manual':
            targetId = 'page-bottom'; // Manual → 最底部
            break;
          default:
            return;
        }

        // 执行平滑滚动
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth', // 平滑滚动
            block: 'start' // 目标元素顶部对齐视口顶部
          });
        }
      });
    },
    aic(type) {
      if (this.isMobile == 1) {
        this.mobileSelShow2 = false
      }
      this.currentIndex = 0
      this.aicType = type;
      if (this.aicType == 0) {
        this.getImgArr('design_highlight')
      }
      if (this.aicType == 1) {
        this.getImgArr('exquisite_detail')
      }
      if (this.aicType == 2) {
        this.getImgArr('flybridge')
      }
    },
    async openModal(type) {
      console.log(type)
      if (type == 1) {

        if (this.aicType == 0) {
          for (let i = 0; i < this.yachatdDetail.images.length; i++) {
            if (this.yachatdDetail.images[i].image_type == 'design_highlight') {
              this.selectedImageSrc = 'https://app.choisiyachts.com' + this.yachatdDetail.images[i].image_url.split(',')[this.currentIndex] || ''
              this.showModal = true;

            }
          }
        }
        if (this.aicType == 1) {
          for (let i = 0; i < this.yachatdDetail.images.length; i++) {
            if (this.yachatdDetail.images[i].image_type == 'exquisite_detail') {
              this.selectedImageSrc = 'https://app.choisiyachts.com' + this.yachatdDetail.images[i].image_url.split(',')[this.currentIndex] || ''
              this.showModal = true;

            }
          }
        }
        if (this.aicType == 2) {
          for (let i = 0; i < this.yachatdDetail.images.length; i++) {
            if (this.yachatdDetail.images[i].image_type == 'flybridge') {
              this.selectedImageSrc = 'https://app.choisiyachts.com' + this.yachatdDetail.images[i].image_url.split(',')[this.currentIndex] || ''
              this.showModal = true;

            }
          }
        }

        this.selectedImageSrc = 'https://app.choisiyachts.com' + await this.getImg('technical', aicType)
      } else {
        this.selectedImageSrc = 'https://app.choisiyachts.com' + type
        this.showModal = true;
      }
      // if (type == 2) {
      //   for (let i = 0; i < this.yachatdDetail.images.length; i++) {
      //     if (this.yachatdDetail.images[i].image_type == 'lower_deck') {
      //       this.selectedImageSrc = 'https://app.choisiyachts.com' + this.yachatdDetail.images[i].image_url.split(',')[0] || ''
      //       this.showModal = true;

      //     }
      //   }
      // }
      // if (type == 3) {
      //   for (let i = 0; i < this.yachatdDetail.images.length; i++) {
      //     if (this.yachatdDetail.images[i].image_type == 'material_selection') {
      //       this.selectedImageSrc = 'https://app.choisiyachts.com' + this.yachatdDetail.images[i].image_url.split(',')[0] || ''
      //       this.showModal = true;
      //     }
      //   }

      // }
      // if (type == 4) {
      //   for (let i = 0; i < this.yachatdDetail.images.length; i++) {
      //     if (this.yachatdDetail.images[i].image_type == 'exterior_gallery') {
      //       this.selectedImageSrc = 'https://app.choisiyachts.com' + this.yachatdDetail.images[i].image_url.split(',')[0] || ''
      //       this.showModal = true;
      //     }
      //   }

      // }
    },
    closeModal() {
      this.showModal = false;
    },
  }
}
</script>

<style>
.slide-down-enter-from,
.slide-down-leave-to {
  height: 0;
  opacity: 0;
  overflow: hidden;
}

/* 过渡过程 */
.slide-down-enter-active,
.slide-down-leave-active {
  height: auto;
  opacity: 1;
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease;
}

/* 图标旋转动画：展开时向下旋转180度 */
.rotate-icon {
  transform: translate(0, -50%) rotate(180deg) !important;
}

/* 原有样式保持不变 */
.yacht {
  width: 100%;
}

.yacht_mobile {
  height: 88%;
}

.yacht-top {
  position: relative;
  width: 100%;
}

.yacht-top_mobile {
  height: 250px;
}

.yacht-bg1 {
  width: 100%;
}

.yacht-box {
  padding-left: 20px;
  box-sizing: border-box;
  border-left: 1px solid #FFFFFF;
  position: absolute;
  z-index: 5;
  bottom: 60px;
  right: 60px;
  height: 120px;
  border-radius: 0px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.yacht-title {
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 120px;
  color: #FFFFFF;
  margin-right: 180px;
}

.yachtt-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.yacht-nums {
  align-items: center;
  margin-left: 67px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.yacht-num {
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 42px;
  color: #FFFFFF;
}

.yacht-num-title {
  margin-top: 5px;
  text-align: center;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
}

.yacht-top-bgsm {
  position: absolute;
  bottom: -35%;
  transform: translate(0, -50%);
  left: 5%;
  width: 35%;
  height: 38%;
  border-radius: 0px 0px 0px 0px;
}

.yacht-top-bgsm_mobile {
  left: 10px;
  width: 140px;
  height: 85px;
}

.yacht-center-text {
  width: 1400px;
  margin: 260px auto 40px;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #021131;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.yacht-center-text_mobile {
  letter-spacing: 1px;
  width: 94%;
  margin: 0px auto;
  margin-top: 60px;
  font-size: 16px;
  line-height: 22px;
}

.yacht-bg2 {
  width: 100%;
  height: 800px;
  border-radius: 0px 0px 0px 0px;
  margin-bottom: 20px;
}

.yacht-bg2_mobile {
  margin-bottom: 1px;
  height: 200px;
}

.yacht-sels {
  height: 85px;
  position: relative;
  padding: 0px 200px 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #6488C6;
  margin: 0px auto;
  width: 1800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #021131;
  margin-bottom: 40px;
}

.yacht-sels_mobile {
  z-index: 99;
  display: flex;
  align-items: center;
  margin: 0px auto;
  position: relative;
  width: 95%;

}

.tcMobile {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.tcMobilecontent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 50%;
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 22px;
}

.yacht-sel-boxs {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 80%;
  height: 100%;
}

.yacht-sel {
  height: 60px;
  margin-top: 20px;
}

.yacht-sel-logo {
  width: 75px;
  height: 70px;
}

.sel_img_mobile {
  width: 20px;
  height: 10px;
  transform: rotateX(180deg);

}

.yacht-sel-logo_mobile {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translate(0, -70%);
  width: 50px;
  height: 42px;
}

.yacht-sel-text1 {
  width: 1400px;
  margin: 0px auto 40px;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #021131;
  line-height: 25px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.yacht-sel-text1_mobile {
  letter-spacing: 1px;
  width: 94%;
  margin: 10px auto;
}

.yacht-sel-text2 {
  box-sizing: border-box;
  padding: 30px 260px 0px 360px;
  width: 1050px;
  height: 710px;
  background: #F0F3F9;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #021131;
  line-height: 25px;
  word-wrap: break-word;
  overflow-wrap: break-word;


  display: -webkit-box;
  /* 设置为WebKit内核的弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 3;
  /* 限制显示三行 */
  overflow: hidden;
}

.yacht-sel-text3 {
  box-sizing: border-box;
  width: 100%;
  background: #F0F3F9;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #021131;
  line-height: 25px;
  word-wrap: break-word;
  overflow-wrap: break-word;


  display: -webkit-box;
  /* 设置为WebKit内核的弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 8;
  /* 限制显示三行 */
  overflow: hidden;
}

.yacht-sel-text2_mobile {
  padding: 0px;
  width: 205px;
  height: 120px;
  overflow: hidden;
  padding-right: 50px;
  padding-left: 15px;
  box-sizing: border-box;

  line-height: 30px;
  /* 每行高度 */
  /* 最大高度為 3 行 */
  overflow: hidden;
  /* 隱藏超出內容 */
  text-overflow: ellipsis;
  /* 顯示省略號 */
  /* 顯示省略號 */
}

.yacht-sel-text3_mobile {
  padding: 0px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;

  line-height: 30px;
  /* 每行高度 */
  /* 最大高度為 3 行 */
  overflow: hidden;
  /* 隱藏超出內容 */
  text-overflow: ellipsis;
  display: -webkit-box;
  /* 设置为WebKit内核的弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 3;
  /* 顯示省略號 */
  /* 顯示省略號 */
}

.yacht-sel-img-box {
  margin: 0px auto 40px;
  margin-top: -680px;
  width: 1400px;
}

.yacht-sel-img-box_mobile {
  margin-top: -120px;
  width: 100%;
}

.yacht-sel-img1 {

  margin-right: 20px;
  width: 690px;
  height: 431px;
  border-radius: 0px 0px 0px 0px;
}

.yacht-sel-img1_mobile {
  margin-left: 10px;
  width: 45%;
  height: 150px;
}

.yacht-sel-img2 {
  width: 690px;
  height: 789px;
  border-radius: 0px 0px 0px 0px;
  margin-bottom: 20px;
}

.yacht-sel-img2_mobile {
  width: 45%;
  height: 256px;
}

.yacht-sel-img3 {
  margin-right: 20px;
  width: 690px;
  height: 431px;
  border-radius: 0px 0px 0px 0px;
}

.yacht-sel-img3_mobile {
  margin-left: 10px;
  width: 45%;
  height: 216px;
}

.yacht-sel-img4 {
  width: 690px;
  height: 453px;
  border-radius: 0px 0px 0px 0px;
}

.yacht-sel-img4_mobile {
  width: 45%;
  height: 226px;
}

.yacht-detail {
  margin-top: 60px;
}

.yacht-detail-title {
  text-align: center;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 52px;
  color: #021131;
  margin-bottom: 40px;
}

.yacht-detail-title_mobile {
  font-size: 26px;
}

.yacht-detail-sel {
  position: relative;
  width: 1800px;
  margin: 0px auto 40px;
  border-bottom: 1px solid #6488C6;
  font-family: Arial, sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #021131;
  height: 62px;
}

.yacht-detail-sel-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: 80%;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  /* transform: translate(-50%, 0); */
}

.yacht-detail-sel-title {
  box-sizing: border-box;
  margin-top: 17px;
  padding-bottom: 20px;
}

.yacht-detail-img-box {
  width: 1400px;
  height: 700px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px auto 40px;
  position: relative;
  height: 780px;
}

.yacht-detail-img {
  width: 1400px;
  height: 700px;
  border-radius: 0px 0px 0px 0px;
}

.yacht-detail-img_mobile {
  width: 100%;
  height: 250px;
}

.yacht-detail-leftright {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.yacht-detail-leftright_mobile {
  margin-top: 5px;
}

.yacht-detail-toleft {
  margin-right: 30px;
  width: 50px;
  height: 50px;
}

.yacht-detail-toright {
  width: 50px;
  height: 50px;
}

.yacht-detail-tobig {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 0;
  bottom: 0;
}

.yacht-detail-cont {
  text-align: center;
  margin-bottom: 40px;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 36px;
  color: #021131;
  line-height: 36px;
}

.yacht-detail-cont_mobile {
  font-size: 30px;
  margin-top: 60px;
}

.yacht-detail-cont-box {
  width: 1400px;
  margin: 0px auto 40px;
  display: flex;
  align-items: center;
}

.yacht-detail-cont-box_mobile {
  width: 100%;
}

.yacht-detail-cont-img {
  margin-right: 80px;
  width: 690px;
  height: 345px;
  border-radius: 0px 0px 0px 0px;
}

.yacht-detail-cont-img_mobile {
  width: 200px;
  height: 150px;
  margin-right: 5px;
}

.yacht-detail-cont-text {
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #021131;
}

.yacht-detail-cont-text_mobile {
  font-size: 15px;
}

.ydct_line {
  display: flex;
  align-items: center;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 36px;
  color: #021131;
}

.ydct_line_mobile {
  font-size: 15px;
}

.ydct_line_line {
  margin-right: 20px;
  position: relative;
}

.ydct_line_line_pos {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #6488C6;
  width: 50%;
}

.yacht-detail-sm {
  display: flex;
  align-items: center;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: #021131;
  width: 74%;
  margin: 0px auto;
}

.yacht-detail-sm_mobile {
  font-size: 20px;
  width: 94%;
}

.yacht-detail-sm-title {
  padding-bottom: 20px;
}

.ydst_sel {
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #6488C6;
  border-bottom: 5px solid #6488C6;
}

.ydst_line {
  margin: -4px auto 0px;
  width: 1800px;
  height: 1px;
  background: #6488C6;
  border-radius: 0px 0px 0px 0px;
}

.ydst_line_mobile {
  width: 100%;
}

.ydst_spec_bigbox {
  width: 75%;
  margin: 40px auto;
  font-family: Arial, sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #021131;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
}

.ydst_spec_bigbox_mobile {
  width: 94%;
  margin: 20px auto;
}

.ydst_spec {
  margin-right: 50px;
  margin-bottom: 60px;
  width: 300px;
}

.ydst_spec_mobile {
  margin-right: 60px;
  font-size: 15px;
  width: 100px;
}

.ydstsb_line {
  margin: 15px auto;
  width: 670px;
  height: 1px;
  background: #F0F3F9;
  border-radius: 0px 0px 0px 0px;
}

.ydstsb_line_mobile {
  width: 100%;

}

.yacht-detail-sm-img-box {
  box-sizing: border-box;
  border-bottom: 1px solid #6488C6;
  margin: 0px auto;
  width: 92%;
  padding-left: 150px;
  border-radius: 0px 0px 0px 0px;
  margin-bottom: 40px;
  padding-bottom: 20px;
}

.yacht-detail-sm-img-box_mobile {
  padding-left: 0px;
  padding-top: 10px;
}

.ydsib_line {
  display: flex;
  align-items: end;
  margin-bottom: 30px;
}

.yacht-detail-sm-img {
  margin-right: 20px;
  object-fit: cover;
  height: 300px;
  border-radius: 0px 0px 0px 0px;
}

.yacht-detail-sm-img_mobile {
  height: 150px;
}

.yacht-detail-sm-img-tobig_mobile {
  width: 25px;
  height: 25px;
}

.yacht-detail-sm-img-text_mobile {
  font-size: 22px;
}

.yacht-detail-bot-img-box {
  height: 260px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.yacht-detail-bot-img-box_mobile {
  padding-top: 20px;
  height: 120px;

}

.yacht-detail-bot-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.yacht-detail-bot-img-text {
  position: relative;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 52px;
  color: #FFFFFF;
  margin-bottom: 40px;
}

.yacht-detail-bot-img-text_mobile {
  font-size: 30px;
  margin-bottom: 20px;

}

.acht-detail-bot-img-buts {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.acht-detail-bot-img-buts_mobile {
  width: 80%;
}

.yacht-detail-bot-img-but {
  position: relative;
  text-align: center;
  line-height: 48px;
  width: 210px;
  height: 48px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #6488C6;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-image {
  width: 100%;
  height: 100%;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 30px;
  color: black;
  cursor: pointer;
}

/* 添加浮现动画样式 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  opacity: 0;
  animation: fadeIn 0.8s ease-out forwards;
}

/* 基础模块延迟设置（按从上到下顺序） */
.yacht-top {
  animation-delay: 0s;
}

.yacht-center-text {
  animation-delay: 0.5s;
}

.yacht-bg2 {
  animation-delay: 1s;
}

.yacht-sels {
  animation-delay: 1.2s;
}

.yacht-sel-box {
  animation-delay: 1.4s;
}
</style>